import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useMatch } from 'react-router-dom';
import { ReactComponent as Logo } from '$/assets/BixLogo.svg';
import Error from '$/components/global/error/Error';
import Info from '$/components/global/info/Info';
import { VERIFY_COMPANY_SUCCESS_MESSAGE } from '$/core/constants';
import { AppState } from '$/store';
import * as VerifyCompanyActions from '$/store/verify-company/actions';

interface IVerifyCompanyRouteProps {
  clientId: string;
  code: string;
}

interface IVerifyCompanyProps extends IVerifyCompanyRouteProps {
  dispatchVerifyCompanyRequest: (clientId: string, token: string) => Promise<void>;
  isLoading: boolean;
  error?: string;
  success: boolean;
  tokenInvalid: boolean;
}

const VerifyCompany: React.FC<IVerifyCompanyProps> = props => {
  const { isLoading, error, success, tokenInvalid, dispatchVerifyCompanyRequest } = props;

  const match = useMatch('/verifyCompany/:clientId?/:code?');

  useEffect(() => {
    const verifyToken = async () => {
      await dispatchVerifyCompanyRequest(match?.params?.clientId ?? '', match?.params.code ?? '');
    };
    verifyToken();
  }, [dispatchVerifyCompanyRequest, match]);

  const verifyCompanySuccess: JSX.Element | null = success ? (
    <div>
      <Info>{VERIFY_COMPANY_SUCCESS_MESSAGE}</Info>
      <Info>
        <Link className="link_underline" to={`/portfolio`}>
          Go to portfolio
        </Link>
      </Info>
    </div>
  ) : null;

  const display: JSX.Element | null = isLoading ? (
    <div>Loading...</div>
  ) : tokenInvalid ? (
    <div>
      <Error>Invalid token</Error>
      <Info>
        <Link className="link_underline" to={`/portfolio`}>
          Go to portfolio
        </Link>
      </Info>
    </div>
  ) : error ? (
    <div>
      <Error>{error}</Error>
      <Info>
        <Link className="link_underline" to={`/portfolio`}>
          Go to portfolio
        </Link>
      </Info>
    </div>
  ) : (
    verifyCompanySuccess
  );

  return (
    <div className="loginPage">
      <div className="content_wrap forgot_password_box">
        <div className="logo_welcome">
          <Logo />
          Verify Company
        </div>
        {display}
      </div>
      <div className="copy_foot">&copy; {new Date().getFullYear()} Bixby Research and Analytics LLC</div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    isLoading: state.verifyCompanyState.isLoading,
    error: state.verifyCompanyState.error,
    success: state.verifyCompanyState.success,
    tokenInvalid: state.verifyCompanyState.tokenInvalid,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchVerifyCompanyRequest: (clientId: string, token: string) =>
    dispatch(VerifyCompanyActions.verifyCompanyRequest(clientId, token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyCompany);
